import React, { useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import sellerData from "../../../Data/sellerlist.json";
import Pagination from "../../Pagination";
import Profile from "../../../../assests/user.png";

const SellerList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const sellersPerPage = 10;
  const indexOfLastSeller = currentPage * sellersPerPage;
  const indexOfFirstSeller = indexOfLastSeller - sellersPerPage;
  const currentSellers = sellerData.slice(
    indexOfFirstSeller,
    indexOfLastSeller
  );
  const totalPages = Math.ceil(sellerData.length / sellersPerPage);
  const [searchTerm, setSearchTerm] = useState("");
  const [dropdownValue, setDropdownValue] = useState("");
  const [optionValue, setOptionValue] = useState("");

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const handleDropdownChange = (event) => {
    setDropdownValue(event.target.value);
  };

  const handleOptionChange = (event) => {
    setOptionValue(event.target.value);
  };

  const filteredSellers = currentSellers.filter((seller) =>
    seller.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Box sx={{ padding: 2, backgroundColor: "#f3f5f9", minHeight: "100vh" }}>
      <Typography variant="h4" gutterBottom>
        Sellers List
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <TextField
          label="Search..."
          variant="outlined"
          value={searchTerm}
          onChange={handleSearch}
          sx={{
            width: { xs: "100%", sm: "200px", md: "250px" },
            height: "40px",
          }}
        />

        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
          <FormControl sx={{ minWidth: { xs: "100%", sm: 200, md: 220 } }}>
            <InputLabel>Show 20</InputLabel>
            <Select
              value={dropdownValue}
              onChange={handleDropdownChange}
              label="Dropdown 1"
            >
              <MenuItem value="option1">Option 1</MenuItem>
              <MenuItem value="option2">Option 2</MenuItem>
              <MenuItem value="option3">Option 3</MenuItem>
            </Select>
          </FormControl>
          <FormControl sx={{ minWidth: { xs: "100%", sm: 200, md: 220 } }}>
            <InputLabel>Status</InputLabel>
            <Select
              value={optionValue}
              onChange={handleOptionChange}
              label="Dropdown 2"
            >
              <MenuItem value="optionA">Pending</MenuItem>
              <MenuItem value="optionB">Fullfilled</MenuItem>
              <MenuItem value="optionC">Rejected</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>
      <TableContainer>
        <Table>
          <TableHead sx={{ backgroundColor: "#f7f8f9" }}>
            <TableRow>
              <TableCell>Seller</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Registered</TableCell>
              <TableCell align="right">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredSellers.map((seller) => (
              <TableRow key={seller.id}>
                <TableCell>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={Profile}
                      alt={seller.name}
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        marginRight: "8px",
                      }}
                    />
                    <Typography>{seller.name}</Typography>
                  </Box>
                </TableCell>
                <TableCell>{seller.email}</TableCell>
                <TableCell>
                  
                  <Typography
                    variant="body2"
                    sx={{
                      display: "inline-flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color:
                        seller.status === "Active"
                          ? "#3bb77e"
                          : seller.status === "inactive"
                          ? "orange"
                          : "red",
                      backgroundColor:
                        seller.status === "Active"
                          ? "rgba(0, 128, 0, 0.1)"
                          : seller.status === "Inactive"
                          ? "rgba(255, 165, 0, 0.1)"
                          : "rgba(255, 0, 0, 0.1)",
                      fontWeight: "bold",
                      padding: "4px 12px",
                      borderRadius: "20px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {seller.status}
                  </Typography>
                </TableCell>
                <TableCell>{seller.registered}</TableCell>
                <TableCell align="right">
                  <Button
                    variant="contained"
                    sx={{ backgroundColor: "#3bb77e" }}
                  >
                    View Details
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination

        totalPages={totalPages}
        currentPage={currentPage}
        onPageChange={handlePageChange}
      />
    </Box>
  );
};

export default SellerList;
